/* eslint-disable jira/filename-case */
import {
	DONE,
	IN_PROGRESS,
	TODO,
	UNDEFINED,
} from '@jira/platform__status-categories/src/status-categories.tsx';

export const START_NODE_ID = 'START';

type TransitionEnum = 'INITIAL' | 'GLOBAL' | 'DIRECTED';

export const transitionType: {
	[key: string]: TransitionEnum;
} = {
	INITIAL: 'INITIAL',
	GLOBAL: 'GLOBAL',
	DIRECTED: 'DIRECTED',
};

export const SCOPE_GLOBAL = 'GLOBAL' as const;
export const SCOPE_PROJECT = 'PROJECT' as const;

export const ALL_OPERATION = 'ALL' as const;

export const STATUS_CATEGORY_WEIGHTS = {
	[TODO]: 1,
	[IN_PROGRESS]: 2,
	[DONE]: 3,
	[UNDEFINED]: 4,
} as const;
export const ANY_OPERATION = 'ANY' as const;

export const errorSeverity = {
	WARNING: 'WARNING',
	ERROR: 'ERROR',
} as const;

export const ruleErrorCodes = {
	FIELD_NOT_FOUND: 'FIELD_NOT_FOUND',
	TRANSITION_SCREEN_FIELD_NOT_FOUND: 'TRANSITION_SCREEN_FIELD_NOT_FOUND',
	FIELD_NOT_PRESENT_IN_ALL_ISSUE_TYPES: 'FIELD_NOT_PRESENT_IN_ALL_ISSUE_TYPES',
	TRANSITION_SCREEN_FIELD_NOT_PRESENT_IN_ALL_ISSUE_TYPES:
		'TRANSITION_SCREEN_FIELD_NOT_PRESENT_IN_ALL_ISSUE_TYPES',
	MISSING_RULE_PARAMETER: 'MISSING_RULE_PARAMETER', // This error is unlikey on load
	PREVIOUS_STATUS_NOT_FOUND: 'PREVIOUS_STATUS_NOT_FOUND',
	FIELD_VALUE_NOT_FOUND: 'FIELD_VALUE_NOT_FOUND',
	UNSUPPORTED_RULE: 'UNSUPPORTED_RULE',
	ASSIGNEE_NOT_FOUND: 'ASSIGNEE_NOT_FOUND',
	PROJECT_ROLE_NOT_FOUND: 'PROJECT_ROLE_NOT_FOUND',
	UNSUPPORTED_FIELD_TYPE_FOR_RULE: 'UNSUPPORTED_FIELD_TYPE_FOR_RULE',
	WORKFLOW_NAME_CONFLICT: 'WORKFLOW_NAME_CONFLICT',
	RESERVED_WORKFLOW_NAME: 'RESERVED_WORKFLOW_NAME',
} as const;
